import { z } from 'zod';
import { endpoint } from './endpoint.js';

export const adminSuppliers = {
  updateIsInternal: endpoint(
    'PATCH',
    '/admin/suppliers/:id/is-internal',
    z.object({
      id: z.coerce.number().int().positive(),
      isInternal: z.boolean(),
    }),
    z.object({
      supplierId: z.number().int().positive(),
      isInternal: z.boolean(),
      jobId: z.string().nullable(),
    }),
  ),
};
